import React, { Component } from "react";
import { Responsive } from "react-admin";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import Tooltip from "@material-ui/core/Tooltip";
import VpnKey from "@material-ui/icons/VpnKey";
import myRestClient from "../common/restClient";
import TranslatedText from "./TranslatedText";
import history from "../common/history";

export default class PasswordReset extends Component {
    state = { showSnackBar: false, error: false };

    reset = () => {
        const { id, redirect } = this.props;
        const params = {
            userId: id
        };
        myRestClient("GET_ONE", "password", params).then(
            () => {
                this.setState({ showSnackBar: true });
                if (redirect) {
                    history.push(redirect);
                }
            },
            () => {
                this.setState({ error: true });
            }
        );
    };

    renderSnackBar() {
        return (
            <Snackbar
                open={this.state.showSnackBar}
                autoHideDuration={6000}
                message={this.renderSnackMessage()}
                onClose={_ =>
                    this.setState({
                        error: false,
                        showSnackBar: false,
                        entity: null
                    })
                }
            />
        );
    }

    renderSnackMessage() {
        return this.state.error === false ? (
            <span id="snack-message">
                <TranslatedText
                    resource_name={`resources.users.actions.activation_link_sent`}
                />
            </span>
        ) : (
            <span id="snack-message">
                <TranslatedText
                    resource_name={`resources.users.actions.activation_link_error`}
                />
            </span>
        );
    }

    render() {
        return (
            <span>
                <Button color="primary" target="_blank" onClick={this.reset}>
                    <Responsive
                        small={
                            <Tooltip
                                title={
                                    <TranslatedText
                                        resource_name={`resources.users.actions.resend_activation_link`}
                                    />
                                }
                            >
                                <VpnKey />
                            </Tooltip>
                        }
                        medium={<VpnKey />}
                    />
                    <span style={{ paddingLeft: "0.5em" }}>
                        <TranslatedText
                            resource_name={`resources.users.actions.resend_activation_link`}
                        />
                    </span>
                </Button>
                {this.renderSnackBar()}
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PasswordReset.js